// src/hooks/useIdSharePoint.ts — SCE Issues
// Identifiant SharePoint (LookupId) d'une personne, par son UPN.
//
// Sert à reconnaître « moi » dans une colonne Personne — les abonnés d'un
// problème (Lot 12). Résolu par ensureUser (users.api.ts), mis en cache pour
// la session : un seul aller-retour, quel que soit le nombre de pages qui le
// demandent. null tant que ce n'est pas résolu, ou si la résolution échoue.

import { useEffect, useState } from 'react'
import { resolveUserLookupId } from '@/api/users.api'

export function useIdSharePoint(upn: string | undefined): number | null {
  return useIdSharePointResolu(upn).id
}

/**
 * Comme `useIdSharePoint`, avec de quoi distinguer « pas encore résolu » de
 * « résolution échouée » (les deux donnent id = null). La cloche « Suivre »
 * d'un problème en a besoin : tant que ce n'est pas résolu, elle ne sait pas
 * si l'on est abonné, et ne doit pas afficher « non suivi ».
 */
export function useIdSharePointResolu(upn: string | undefined): { id: number | null; resolu: boolean } {
  const [etat, setEtat] = useState<{ id: number | null; resolu: boolean }>({ id: null, resolu: false })
  useEffect(() => {
    setEtat({ id: null, resolu: false })
    if (!upn) return undefined
    let actif = true
    void resolveUserLookupId(upn)
      .catch(() => null)
      .then((r) => {
        if (actif) setEtat({ id: r, resolu: true })
      })
    return () => {
      actif = false
    }
  }, [upn])
  return etat
}
